import { useAsyncExecutor2 } from "async-executor-hook";
import { differenceInDays, format } from "date-fns";
import { stringify } from "query-string";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import {
  WCalendar,
  WInputText,
  WMultipleTagInput,
  WMultiSelect,
} from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import { removeNullUndefinedProps } from "../../common/utils";
import { AdminPaymentRecaudoParams$ } from "./AdminPaymentRecaudo.interface";

const PAYMENT_STATUS_OPTION = [
  { value: "pending_payment", label: "PENDIENTE" },
  { value: "paid", label: "PAGADO" },
  { value: "expired", label: "PAGO VENCIDO" },
];
const CASHBACK_STATUS_OPTION = [
  { value: "pending", label: "POR COMPENSAR" },
  { value: "compensating", label: "COMPENSADO" },
  { value: "not_required", label: "NO REQUERIDO" },
];

const BANKS_OPTION = [
  { value: "bbva", label: "BBVA" },
  { value: "bcp", label: "BCP" },
];

export const AdminPaymentRecaudoSearch = (
  props: AdminPaymentRecaudoParams$
) => {
  const { params$ } = props;
  const history = useHistory();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        agent_name: new FormControl(),
        volante_nums: new FormControl(),
        from_date: new FormControl(),
        to_date: new FormControl(),
        bank_type: new FormControl(),
        payment_status_option: new FormControl(),
        cashback_status_option: new FormControl(),
      });
      form.get("from_date").valueChanges.subscribe((from_date: Date) => {
        const toDate = new Date(form.get("to_date").value) || new Date();
        const diffDate = differenceInDays(toDate, new Date(from_date));
        if (diffDate < 1) {
          form.get("to_date").setValue(from_date);
        }
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      const from_date = data.from_date && format(data.from_date, "yyyy-MM-dd");
      const to_date = data.to_date && format(data.to_date, "yyyy-MM-dd");
      const pathname = history.location.pathname;
      history.push(
        `${pathname}?${stringify(
          removeNullUndefinedProps({ ...data, from_date, to_date })
        )}`
      );
    },
  });

  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });

  return (
    <div>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-12 p-md-4">
            <WFormControl name="agent_name">
              <TemplateInputContainer label="Agente de aduana:">
                <WInputText width="100%" placeholder="Nombre del agente" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-12 p-md-4">
            <WFormControl name="bank_type">
              <TemplateInputContainer label="Banco:">
                <WMultiSelect
                  width="100%"
                  placeholder="Seleccionar"
                  options={BANKS_OPTION}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-12 p-md-2">
            <WFormControl name="from_date">
              <TemplateInputContainer label="Fecha desde:" color="#08082B">
                <WCalendar width="100%" dateFormat="dd/mm/yy" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-12 p-md-2">
            <WFormControl name="to_date">
              <TemplateInputContainer label="Fecha hasta:">
                <WCalendar
                  width="100%"
                  minDate={
                    formConfig.form?.get("from_date")?.value || new Date()
                  }
                  dateFormat="dd/mm/yy"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
        </div>
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-12 p-md-4">
            <WFormControl name="volante_nums">
              <TemplateInputContainer label="Volantes:">
                <WMultipleTagInput width="100%" height="5rem" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-12 p-md-4">
            <WFormControl name="payment_status_option">
              <TemplateInputContainer label="Estado:">
                <WMultiSelect
                  width="100%"
                  placeholder="Seleccionar"
                  options={PAYMENT_STATUS_OPTION}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-12 p-md-2">
            <WFormControl name="cashback_status_option">
              <TemplateInputContainer label="Subestado:">
                <WMultiSelect
                  width="100%"
                  placeholder="Seleccionar"
                  options={CASHBACK_STATUS_OPTION}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-12 p-md-2">
            <div style={{ marginBottom: "1.8rem", height: "1.4rem" }} />
            <SaveButton
              label="Consultar"
              width="100%"
              height="5rem"
              backgroundColor="#002E6C"
            />
          </div>
        </div>
      </WForm>
    </div>
  );
};
